<template>
    <div class="data-evaluation-index">
        <keep-alive include="DataEvaluation,AttitudeRanking,LiteracyRanking,TrainRanking">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: "DataEvaluationIndex",
};
</script>

<style lang="scss" scoped>
.data-evaluation-index {
    width: 100%;
    height: 100%;
}
</style>
